import { DocumentUpload } from './types';

export const createDocumentUpload = (): DocumentUpload => ({
  file: null,
  status: "pending",
}); 